/* Riposte — questionnaire de recommandation */
(function () {
  'use strict';

  var root = document.querySelector('[data-rq]');
  if (!root) return;

  /* Amortissement de la jauge. Sans lui, la première réponse suffirait à
     coller le curseur contre une extrémité — un rapport de 1 sur 1 est
     mathématiquement un maximum, mais une seule réponse ne justifie pas
     une certitude. La constante représente le poids d'un doute initial
     que les réponses suivantes doivent progressivement dissoudre. */
  var DAMPING = 20;

  /* Délai entre le clic et la question suivante. Il n'est pas cosmétique :
     c'est le temps nécessaire pour voir le curseur bouger. Le supprimer
     ramènerait le questionnaire à un formulaire. */
  var ADVANCE_MS = 420;

  var answers = {};   // clé -> { v: valeur, w: poids }
  var current = 1;

  var panels = {};
  root.querySelectorAll('[data-rq-panel]').forEach(function (el) {
    panels[el.getAttribute('data-rq-panel')] = el;
  });

  var questions = Array.prototype.slice.call(root.querySelectorAll('[data-rq-q]'));
  var TOTAL = questions.length;

  var bar = root.querySelector('[data-rq-bar]');
  var indexEl = root.querySelector('[data-rq-index]');
  var backBtn = root.querySelector('[data-rq-back]');

  /* La jauge existe en trois exemplaires — accueil, questions, résultat.
     On les pilote toutes ensemble : un visiteur qui revient en arrière
     puis repart ne doit jamais voir deux curseurs en désaccord. */
  var fills = Array.prototype.slice.call(root.querySelectorAll('[data-rq-fill]'));
  var needles = Array.prototype.slice.call(root.querySelectorAll('[data-rq-needle]'));

  /* ---------- poids, lus dans le document ---------- */

  function optionsOf(q) {
    return Array.prototype.slice.call(q.querySelectorAll('[data-v]'));
  }

  /* Poids maximal atteignable sur une question : sert à normaliser. Une
     question à ±35 doit peser trois fois plus qu'une question à ±12. */
  var maxOf = {};
  questions.forEach(function (q) {
    var max = 0;
    optionsOf(q).forEach(function (btn) {
      var w = Math.abs(parseFloat(btn.getAttribute('data-w')) || 0);
      if (w > max) max = w;
    });
    maxOf[q.getAttribute('data-rq-key')] = max;
  });

  function score() {
    var total = 0;
    Object.keys(answers).forEach(function (k) { total += answers[k].w; });
    return total;
  }

  function weighedSoFar() {
    var total = 0;
    Object.keys(answers).forEach(function (k) { total += maxOf[k] || 0; });
    return total;
  }

  /* ---------- jauge ---------- */

  function paintGauge() {
    var ratio = score() / (weighedSoFar() + DAMPING);   // borné à ]-1, 1[
    var pos = 50 + ratio * 50;
    if (pos < 4) pos = 4;
    if (pos > 96) pos = 96;

    var left = pos >= 50 ? 50 : pos;
    var width = Math.abs(pos - 50);

    fills.forEach(function (el) {
      el.style.left = left + '%';
      el.style.width = width + '%';
    });
    needles.forEach(function (el) { el.style.left = pos + '%'; });
  }

  /* Le verdict et la jauge lisent la même valeur : le curseur à droite du
     centre annonce forcément la Goutte. Un score nul retombe sur la Ronde,
     la plus tolérante — à égalité, mieux vaut la raquette qui pardonne. */
  function recommend() {
    return score() > 0 ? 'goutte' : 'ronde';
  }

  /* ---------- affichage ---------- */

  function showPanel(name) {
    Object.keys(panels).forEach(function (k) {
      panels[k].classList.toggle('rq__step--active', k === name);
    });
    var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function showQuestion(n) {
    current = n;
    questions.forEach(function (q) {
      var isCurrent = parseInt(q.getAttribute('data-rq-q'), 10) === n;
      q.hidden = !isCurrent;
      q.classList.remove('rq__q--in');
      if (isCurrent) {
        void q.offsetWidth;            // force le navigateur à rejouer l'animation
        q.classList.add('rq__q--in');
      }
    });
    bar.style.width = ((n - 1) / TOTAL) * 100 + '%';
    indexEl.textContent = n;
    backBtn.hidden = n === 1;
  }

  /* ---------- navigation ---------- */

  root.querySelector('[data-rq-start]').addEventListener('click', function () {
    showPanel('questions');
    showQuestion(1);
  });

  function answer(q, btn) {
    var key = q.getAttribute('data-rq-key');
    answers[key] = {
      v: btn.getAttribute('data-v'),
      w: parseFloat(btn.getAttribute('data-w')) || 0
    };

    optionsOf(q).forEach(function (b) {
      b.classList.toggle('rq__opt--on', b === btn);
    });

    paintGauge();

    window.setTimeout(function () {
      if (current < TOTAL) {
        showQuestion(current + 1);
      } else {
        bar.style.width = '100%';
        showPanel('email');
      }
    }, ADVANCE_MS);
  }

  questions.forEach(function (q) {
    optionsOf(q).forEach(function (btn, i) {
      /* Le numéro est ajouté ici et non dans le gabarit : il doit rester
         cohérent avec la touche du clavier, donc dériver du même index. */
      var k = document.createElement('span');
      k.className = 'rq__opt-k';
      k.setAttribute('aria-hidden', 'true');
      k.textContent = i + 1;
      btn.insertBefore(k, btn.firstChild);

      btn.addEventListener('click', function () { answer(q, btn); });
    });
  });

  backBtn.addEventListener('click', function () {
    if (current > 1) showQuestion(current - 1);
  });

  /* Clavier : uniquement pendant les questions, jamais pendant la saisie
     de l'email — sans quoi taper « 1 » dans une adresse validerait une
     réponse. La vérification du panneau actif suffit, les deux écrans
     ne sont jamais visibles en même temps. */
  document.addEventListener('keydown', function (e) {
    if (!panels.questions.classList.contains('rq__step--active')) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;

    if (e.key === 'ArrowLeft' || e.key === 'Backspace') {
      if (current > 1) { e.preventDefault(); showQuestion(current - 1); }
      return;
    }

    var n = parseInt(e.key, 10);
    if (!n) return;
    var q = questions[current - 1];
    var opts = optionsOf(q);
    if (n >= 1 && n <= opts.length) {
      e.preventDefault();
      opts[n - 1].focus();
      answer(q, opts[n - 1]);
    }
  });

  /* ---------- email ---------- */

  var form = root.querySelector('[data-rq-form]');
  var input = form.querySelector('input[type="email"]');
  var errorEl = root.querySelector('[data-rq-error]');
  var submitBtn = root.querySelector('[data-rq-submit]');

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var value = input.value.trim();

    if (!validEmail(value)) {
      errorEl.hidden = false;
      input.focus();
      return;
    }
    errorEl.hidden = true;

    var pick = recommend();
    var label = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Un instant…';

    // Inscription via le formulaire client natif de Shopify.
    // L'échec ne doit jamais bloquer l'affichage du résultat.
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', value);
    body.append('contact[tags]', 'quiz,quiz-' + pick);

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'contact' : '/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .catch(function () { /* silencieux, volontairement */ })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = label;
        renderResult(pick);
      });
  });

  /* ---------- résultat ---------- */

  function renderResult(pick) {
    var titleEl = root.querySelector('[data-rq-result-title]');
    var whyEl = root.querySelector('[data-rq-result-why]');
    var otherBtn = root.querySelector('[data-rq-other]');

    var name = root.getAttribute('data-' + pick + '-title');
    var other = pick === 'goutte' ? 'ronde' : 'goutte';
    var otherName = root.getAttribute('data-' + other + '-title');

    titleEl.textContent = 'Votre raquette : ' + name;
    whyEl.textContent = root.getAttribute('data-why-' + pick) || '';

    root.querySelectorAll('[data-rq-card]').forEach(function (card) {
      card.hidden = card.getAttribute('data-rq-card') !== pick;
    });

    root.querySelectorAll('[data-rq-shape]').forEach(function (fig) {
      fig.hidden = fig.getAttribute('data-rq-shape') !== pick;
    });

    var fip = root.querySelector('[data-rq-note-fip]');
    var budget = root.querySelector('[data-rq-note-budget]');
    if (fip) fip.hidden = !answers.tournoi || answers.tournoi.v !== 'oui';
    if (budget) budget.hidden = !answers.budget || answers.budget.v !== 'bas';

    otherBtn.textContent = 'Voir plutôt ' + otherName;
    otherBtn.onclick = function () { renderResult(other); };

    showPanel('result');
  }

  /* Passer l'étape mène au même résultat, sans requête réseau : rien à
     envoyer, rien à attendre. Le visiteur qui refuse de donner son
     adresse ne doit pas être puni par une seconde de chargement. */
  var skipBtn = root.querySelector('[data-rq-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', function () { renderResult(recommend()); });
  }

  root.querySelector('[data-rq-restart]').addEventListener('click', function () {
    answers = {};
    root.querySelectorAll('.rq__opt--on').forEach(function (b) {
      b.classList.remove('rq__opt--on');
    });
    input.value = '';
    paintGauge();
    showPanel('intro');
  });

  paintGauge();
})();
